module.exports = __webpack_public_path__ + "fonts/OpenSans-LightItalic.8592c37b.woff";